import React from 'react';

import { BusinessRolesObject, UserPermissions } from 'src/constants/user';
import { getBusinessRoles, isKnownBusinessRole } from 'src/utils/role';
import { isUserPermissionsKey } from 'src/utils/user';

import { useCurrentUser } from './useCurrentUser';

export const useCurrentUserPermissions = () => {
  const { user, isUserLoading } = useCurrentUser();

  const userPermissions = React.useMemo((): UserPermissions => {
    const userPermissions: UserPermissions = {
      isPlatformAdmin: false,
      isPlatformManager: false,
      isEmployerAdmin: false,
      isEmployerManager: false,
      isVerifierAdmin: false,
      isVerifierManager: false,
      isEmployee: false,
      isPeoManager: false,
      isPeoAdmin: false,
      isPeoSuperAdmin: false,
      isPeoPayrollProviderUser: false,
      hasPlatformRoles: false,
      hasEmployerRoles: false,
      hasVerifierRoles: false,
      hasPeoRoles: false,
    };

    const businessRoles = getBusinessRoles(user);

    if (businessRoles.length === 0) return userPermissions;

    for (const businessRole of businessRoles) {
      const roleName = businessRole;

      if (!isKnownBusinessRole(roleName)) break;

      for (const [objectKey, systemRoleNames] of Object.entries(BusinessRolesObject)) {
        if (systemRoleNames.includes(roleName) && isUserPermissionsKey(objectKey)) {
          userPermissions[objectKey] = true;
        }
      }
    }

    return userPermissions;
  }, [user]);

  return { ...userPermissions, loading: isUserLoading };
};
